<template>
  <div
    class="blocco_sfumato cf cancel-button"
    :class="{ 'add-margin': isUsedInsideNewReservedArea }"
  >
    <div v-if="!isUsedInsideNewReservedArea" class="titolo title">
      SERVIZI INTEGRATIVI
    </div>
    <div :class="{ 'center-service-button': isUsedInsideNewReservedArea }">
      <DxButton
        :height="'65%'"
        text="ACCEDI AL SERVIZIO ECQUESITI"
        type="default"
        styling-mode="contained"
        @click="onClick(event)"
      />
    </div>
  </div>
</template>
<script>
import { DxButton } from 'devextreme-vue/button'

export default {
  name: 'EcSupplementaryServices',
  components: { DxButton },
  props: {
    tokenFromNewReservedArea: {
      type: String,
      default: '',
    },
    courseCodeFromNewReservedArea: {
      type: String,
      default: '',
    },
    orderLocationFromNewReservedArea: {
      type: String,
      default: '',
    },
    isUsedInsideNewReservedArea: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      url: '',
      result: null,
      utToken: null,
      courseCode: null,
      orderSite: null,
      userId: null,
      userName: null,
      userMail: null,
      userFiscalCode: null,
    }
  },
  created() {
    const teachingMaterialsGrid = document.querySelector(
      '#ec-supplementary-services'
    )
    if (teachingMaterialsGrid) {
      this.url = 'https://quesiti.ecplanner.it/register.php'
      this.utToken = teachingMaterialsGrid.getAttribute('utToken')
      this.courseCode = teachingMaterialsGrid.getAttribute('courseCode')
      this.orderSite = teachingMaterialsGrid.getAttribute('orderSite')
    } else {
      this.url = 'https://quesiti.ecplanner.it/register.php'
      this.utToken = this.tokenFromNewReservedArea
      this.courseCode = this.courseCodeFromNewReservedArea
      this.orderSite = this.orderLocationFromNewReservedArea
    }
    this.userId = localStorage.getItem('UserID')

    this.apiService.usersApi.getUserById(this.userId).then(res => {
      this.userName = res[0].uT_CognomeNomeCompleto
      this.userMail = res[0].uT_Email
      this.userFiscalCode = res[0].uT_CF
    })
  },
  mounted() {},
  methods: {
    postData(params) {
      const form = document.createElement('form')
      form.method = 'post'
      form.action = this.url
      form.target = '_blank'
      form.enctype = 'multipart/form-data'

      for (const key in params) {
        if (Object.prototype.hasOwnProperty.call(params, key)) {
          const hiddenField = document.createElement('input')
          hiddenField.type = 'hidden'
          hiddenField.name = key
          hiddenField.value = params[key]
          form.appendChild(hiddenField)
        }
      }

      document.body.appendChild(form)
      form.submit()
    },

    onClick() {
      const data = {
        codcli: this.userId,
        codfisc: this.userFiscalCode,
        nome: this.userName,
        cognome: '',
        email: this.userMail,
        corso: this.courseCode,
        sede: this.orderSite,
        token: this.utToken,
      }
      this.postData(data)
    },
  },
}
</script>
<style scoped>
.table-header {
  text-transform: uppercase;
  text-align: left;
  background: #00a0dc;
  color: white;
  padding: 10px;
  font: 14px/14px pt_sansregular;
}
.subelement-headers {
  margin-top: 25px;
}
.center-service-button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.add-margin {
  margin-top: 2rem;
  height: 70px;
}
</style>
<style>
.dx-row.dx-data-row.dx-row-lines {
  text-wrap: pretty;
}
</style>
